export function upButton() {
  const px_change = 200;
  const target = document.querySelector('#c-button__up');
  target.classList.add('is-inactive');

  window.addEventListener('scroll', function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > px_change) {
      target.classList.add('is-active');
      target.classList.remove('is-inactive');
    } else {
      target.classList.add('is-inactive');
      target.classList.remove('is-active');
    }
  });

  window.addEventListener('scroll', function () {
    const contentContact = document.querySelector('#content__contact');
    if (contentContact) {
      const bodyHeight = document.body.clientHeight;
      const windowHeight = window.innerHeight;
      const bottomPoint = bodyHeight - windowHeight;
      const currentPos = window.pageYOffset;

      if (bottomPoint <= currentPos) {
        target.classList.add('is-bottom');
      } else {
        target.classList.remove('is-bottom');
      }
    }
  });

  target.addEventListener('click', function () {
    scrollToTop(500);
  });

  function scrollToTop(duration) {
    const start = window.pageYOffset;
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

    function animateScroll() {
      const currentTime = 'now' in window.performance ? performance.now() : new Date().getTime();
      const elapsedTime = currentTime - startTime;
      const scrollTo = Math.easeInOutQuad(elapsedTime, start, -start, duration);

      window.scrollTo(0, scrollTo);

      if (elapsedTime < duration) {
        requestAnimationFrame(animateScroll);
      }
    }

    // Easing equation for smooth scrolling
    Math.easeInOutQuad = function (t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    requestAnimationFrame(animateScroll);
  }
}
